import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Solutions from './pages/Solutions';
import About from './pages/About';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import AskDemo from './pages/AskDemo';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      {/* Add margin-top equal to navbar height here */}
      <main style={{ marginTop: '64px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/ask-demo" element={<AskDemo />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
